import * as React from 'react';
import { useCallback, useReducer } from 'react';

import { Duration } from '../..';
import { NotificationContext } from '../../context/NotificationContext';
import { initialState, NotificationAction, notificationReducer } from '../../reducers/notificationReducer';
import { NotifyFunction } from '../../types/NotifyFunction';
import { randomString } from '../../util/randomString';

export const NotificationManager = ({ children, limit = 0 }: { children: React.ReactNode; limit?: number }) => {
    const [{ notifications }, dispatch] = useReducer(notificationReducer, { ...initialState, limit });

    const notify: NotifyFunction = useCallback((content, level, duration = Duration.SHORT) => {
        const id = randomString();

        dispatch({ type: NotificationAction.ADD, content, level, duration, id });
        setTimeout(() => dispatch({ type: NotificationAction.DELETE, id }), duration);
    }, []);

    return <NotificationContext.Provider value={{ notifications, notify }}>{children}</NotificationContext.Provider>;
};
